import React from 'react';
import './styles/HeroBanner.css';

const HeroBanner = () => {
  return (
    <div className="hero-container">
        
    </div>
  )
}

export default HeroBanner;